import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import InventoryHeader from './InventoryHeader';
import Loading from '../Loading';
import { Table } from 'react-bootstrap';
import { getStockStatusLabelByUom } from './stockStatus';

const matchesSearch = (stock, searchQuery) => {
    const normalizedSearch = searchQuery.trim().toLowerCase();

    if (!normalizedSearch) {
        return true;
    }

    return [
        stock.sku,
        stock.name,
        stock.category,
        stock.base_uom,
    ]
        .filter(Boolean)
        .some((value) => String(value).toLowerCase().includes(normalizedSearch));
};

@inject('ComponentStockStore')
@observer
class CriticalStockStatus extends Component {
    state = {
        searchQuery: '',
    };

    componentDidMount = () => {
        const {
            ComponentStockStore: { handleGetCriticalStockStatus },
        } = this.props;

        handleGetCriticalStockStatus();
    };

    render() {
        const {
            ComponentStockStore: { criticalStockStatusLoading, criticalStockStatus },
        } = this.props;
        const { searchQuery } = this.state;

        if (criticalStockStatusLoading) {
            return <Loading />;
        }

        const filteredCriticalStockStatus = criticalStockStatus.filter((stock) => matchesSearch(stock, searchQuery));

        return (
            <Fragment>
                <InventoryHeader title="Critical Stock Status" />
                <div className="inventory-critical-stock">
                    <div className="inventory-dashboard-search">
                        <input
                            className="inventory-dashboard-search__input"
                            type="search"
                            value={searchQuery}
                            onChange={(event) => this.setState({ searchQuery: event.target.value })}
                            placeholder="Search component SKU or name"
                        />
                    </div>
                    {criticalStockStatus.length === 0 ? (
                        <div className="inventory-critical-stock__empty">
                            No critical component SKUs configured.
                        </div>
                    ) : filteredCriticalStockStatus.length === 0 ? (
                        <div className="inventory-dashboard-search__empty">
                            No matching components found.
                        </div>
                    ) : (
                        <Table striped bordered hover className="inventory-critical-stock__table">
                            <thead>
                                <tr>
                                    <th>SKU</th>
                                    <th>Name</th>
                                    <th>Category</th>
                                    <th>Current stock</th>
                                    <th>Pre-orders</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredCriticalStockStatus.map((stock) => (
                                    <tr
                                        key={stock.sku}
                                        className={
                                            stock.unsold <= 0 && !stock.is_sub_component_available
                                                ? 'inventory-critical-stock__row--out'
                                                : ''
                                        }
                                    >
                                        <td>{stock.sku}</td>
                                        <td>{stock.name}</td>
                                        <td>{stock.category || '-'}</td>
                                        <td>{getStockStatusLabelByUom(stock.unsold, stock.base_uom, stock.is_sub_component_available)}</td>
                                        <td>{stock.pre_order_quantity}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    )}
                </div>
            </Fragment>
        );
    }
}

export default CriticalStockStatus;
